"use client"

import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/custolink-newdesign/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "cl:flex cl:items-center cl:gap-2 cl:text-sm cl:leading-none cl:font-medium cl:select-none cl:group-data-[disabled=true]:pointer-events-none cl:group-data-[disabled=true]:opacity-50 cl:peer-disabled:cursor-not-allowed cl:peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
